const CARD_LIST_LIMIT = 5;

export default {
  CARD_LIST_LIMIT,
};
